import { palette, typography } from "@src/core/styles";
import styled from "styled-components";

export const NavContainer = styled.div`
  display: flex;
  & a {
    ${typography.label_large};
    margin-right: 24px;
    &:hover {
      color: ${palette.colors.green_base};
    }
  }
`;

export const NavGroup = styled.div`
  display: flex;
  gap: 16px;
  ${typography.label_large};

  & a {
    margin: 0;
  }
`;
